"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _DownloadCsv = _interopRequireDefault(require("../DownloadCsv"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

var _chartUtils = require("../../chartUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Download = function Download(_ref) {
  var contractGenerationCoordinates = _ref.contractGenerationCoordinates,
      hasBattery = _ref.hasBattery,
      peerAdjCoordinates = _ref.peerAdjCoordinates,
      peerV2Coordinates = _ref.peerV2Coordinates,
      siteCoordinates = _ref.siteCoordinates,
      timeZone = _ref.timeZone,
      internalUsage = _ref.internalUsage;
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)({
    site: siteCoordinates,
    contract: contractGenerationCoordinates,
    peer: peerAdjCoordinates,
    peerV2: peerV2Coordinates
  });
  var downloadFields = [{
    label: 'Time',
    value: 'friendlyDate'
  }, {
    label: hasBattery ? 'System Production (kWh)' : 'Solar (kWh)',
    value: 'site'
  }];

  if (internalUsage) {
    var peer = {
      label: 'Legacy Peer (kWh)',
      value: 'peer'
    };
    var peerV2 = {
      label: 'Peer Adjusted (kWh)',
      value: 'peerV2'
    };
    var contract = {
      label: 'Contracted (kWh)',
      value: 'contract'
    };
    downloadFields.push(peer);
    downloadFields.push(peerV2);
    downloadFields.push(contract);
  }

  return /*#__PURE__*/_react["default"].createElement(_DownloadCsv["default"], {
    data: Object.values(coordinatesGroupedByTime).sort(_chartUtils.sortCoordinatesDescending).map(function (row) {
      return _objectSpread({
        friendlyDate: _luxon.DateTime.fromMillis(row.x, {
          zone: timeZone
        }).toISO()
      }, row);
    }),
    fields: downloadFields,
    fileName: "CumulativeChart"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      height: 31,
      width: 31
    },
    name: "DownloadIcon"
  }));
};

Download.propTypes = {
  contractGenerationCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  })).isRequired,
  hasBattery: _propTypes["default"].bool.isRequired,
  peerAdjCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  })).isRequired,
  peerV2Coordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  })).isRequired,
  siteCoordinates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  })).isRequired,
  timeZone: _propTypes["default"].string.isRequired,
  internalUsage: _propTypes["default"].bool
};
Download.defaultProps = {
  internalUsage: false
};
var _default = Download;
exports["default"] = _default;